import { downloadZip } from '../../export/downloadZip.ts';

export const saveExportPdf = async (pdfs: { blob: Blob; name: string }[], zipName: string) => {
  await downloadZip(pdfs, zipName);
};
